
import { Alert } from "@/pages/Inbox";

export const mockAlerts: Alert[] = [
  {
    id: "1",
    title: "API Service Down",
    service: "Payment Gateway",
    timestamp: "2023-10-15T08:23:45.000Z",
    priority: "high",
    status: "active",
    description: "The payment processing API is returning 500 errors for all requests. Customer transactions are failing.\n\nError: Connection refused to database cluster.\n\nImpact: All payment processing is halted. Estimated impact: $50k revenue per hour.",
  },
  {
    id: "2",
    title: "Database Disk Space Critical",
    service: "User DB Cluster",
    timestamp: "2023-10-15T09:15:22.000Z",
    priority: "high",
    status: "active",
    description: "Primary database server is at 95% disk capacity and will stop accepting writes at 98%.\n\nAutoscaling has been triggered but new nodes are still provisioning.\n\nRecommended action: Clean up temporary tables or archive old data.",
  },
  {
    id: "3",
    title: "CDN Cache Miss Rate Increasing",
    service: "Content Delivery",
    timestamp: "2023-10-15T07:45:10.000Z",
    priority: "medium",
    status: "acknowledged",
    description: "Cache miss rate has increased from 15% to 45% in the last hour. This is causing increased load on origin servers and higher latency for users.\n\nPossible causes:\n- Recent deployment invalidating caches\n- Configuration change\n- DDoS attack",
  },
  {
    id: "4",
    title: "Memory Leak Detected",
    service: "Recommendation Engine",
    timestamp: "2023-10-14T23:12:38.000Z",
    priority: "medium",
    status: "active",
    description: "Memory usage in the recommendation service is steadily increasing, indicating a potential memory leak. Current usage: 85% of available memory.\n\nThe service will be automatically restarted if it reaches 95%, but this will cause a brief disruption to recommendations.",
  },
  {
    id: "5",
    title: "SSL Certificate Expiring",
    service: "Security",
    timestamp: "2023-10-14T14:30:00.000Z",
    priority: "low",
    status: "active",
    description: "The SSL certificate for api.example.com will expire in 10 days. Please renew the certificate to prevent service disruption.\n\nRenewal process:\n1. Generate CSR\n2. Submit to Certificate Authority\n3. Install new certificate\n4. Verify HTTPS access",
  },
  {
    id: "6",
    title: "Elevated Error Rates - Login Service",
    service: "Authentication",
    timestamp: "2023-10-15T10:05:12.000Z",
    priority: "high",
    status: "active",
    description: "Error rates for the login service have increased to 12% (threshold: 5%).\n\nUsers are experiencing intermittent failures when attempting to log in. Authentication backend is showing increased latency.\n\nRecent changes: Updated identity provider integration (deployed 1 hour ago).",
  },
  {
    id: "7",
    title: "Backup Job Failed",
    service: "Data Operations",
    timestamp: "2023-10-15T02:00:00.000Z",
    priority: "medium",
    status: "active",
    description: "The nightly backup job failed to complete successfully. Error message: 'Insufficient permissions to write to backup storage location'.\n\nThis is the second consecutive failure. Our backup retention policy requires successful backups every 48 hours.",
  },
  {
    id: "8",
    title: "Unusual Traffic Pattern Detected",
    service: "Security",
    timestamp: "2023-10-15T06:17:33.000Z",
    priority: "low",
    status: "acknowledged",
    description: "Our anomaly detection system has identified unusual traffic patterns from several IP ranges. This may indicate a potential credential stuffing attack.\n\nCurrently, our rate limiting is preventing any account compromises, but the situation should be monitored.",
  },
  {
    id: "9",
    title: "High CPU Usage - Analytics Cluster",
    service: "Data Analytics",
    timestamp: "2023-10-15T11:22:45.000Z",
    priority: "medium",
    status: "active",
    description: "The analytics processing cluster has sustained CPU usage above 85% for the past 30 minutes.\n\nThis coincides with the scheduled data aggregation jobs, but usage is higher than normal. Performance for dashboard users may be degraded during this period.",
  },
  {
    id: "10",
    title: "Payment Gateway Latency Spike",
    service: "Payment Processing",
    timestamp: "2023-10-15T09:30:18.000Z",
    priority: "medium",
    status: "active",
    description: "Response times from our payment gateway provider have increased from 200ms to 800ms average. This is causing slower checkout experiences.\n\nOur provider has acknowledged an incident on their status page but has not provided an ETA for resolution.",
  }
];
